import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator, UploadJob } from '../types';

const updateUploadJobReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<UploadJob>) => {
    state.uploadJobs = state.uploadJobs.map((job) => (job.uuid === action.payload.uuid ? action.payload : job));
  });
};

export default updateUploadJobReducer;
